import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function PageShell({ children, hero = false }) {
  return (
    <div className="App flex flex-col min-h-screen">
      <Navbar />
      <main className={`flex-1 ${hero ? "" : "pt-16"}`}>{children}</main>
      <Footer />
    </div>
  );
}
